import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { DatePicker } from 'antd';
import dayjs, { Dayjs } from "dayjs";
const DateRangeTableFilter = ({ defaultFromValue, defaultToValue, onApplyFilter, onClearFilter }) => {
    const onRangeChange = (dates, dateStrings) => {
        if (dates && dates.length >= 2) {
            const dateFromFilterValue = dates[0] ? [dates[0].format("YYYY-MM-DD")] : null;
            const dateToFilterValue = dates[1] ? [dates[1].format("YYYY-MM-DD")] : null;
            onApplyFilter(dateFromFilterValue, dateToFilterValue);
        }
        else {
            onClearFilter();
        }
    };
    const fromDate = defaultFromValue ? dayjs(defaultFromValue + "") : null;
    const toDate = defaultToValue ? dayjs(defaultToValue + "") : null;
    return (_jsx("div", { className: "swz-calendar-filter-dropdown custom-filter-dropdown", children: _jsx(DatePicker.RangePicker, { defaultValue: [fromDate, toDate], format: 'DD/MM/YYYY', allowClear: true, onChange: onRangeChange, presets: [
                {
                    label: 'Yesterday',
                    value: [dayjs().subtract(1, 'days').startOf('day'), dayjs().subtract(1, 'days').endOf('day')]
                }, {
                    label: 'Today',
                    value: [dayjs().startOf('day'), dayjs().endOf('day')]
                }, {
                    label: 'Tomorrow',
                    value: [dayjs().add(1, 'days').startOf('day'), dayjs().add(1, 'days').endOf('day')]
                }, {
                    label: 'This Week',
                    value: [dayjs().startOf('week'), dayjs().endOf('week')]
                }, {
                    label: 'This Month',
                    value: [dayjs().startOf('month'), dayjs().endOf('month')]
                }, {
                    label: 'Month to date',
                    value: [dayjs().startOf('month'), dayjs().endOf('day')]
                }
            ] }) }));
};
export default DateRangeTableFilter;
